module.exports = __webpack_public_path__ + "static/media/delete-dark.cfdf3381.svg";